import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const InlineCopyButton = ({ text }) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };
    return (
        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-copy">Copiar</Tooltip>}>
            <img
                src={copied ? '/img/check25.png' : '/img/copiar25.png'}
                width={20}
                alt="Copiar"
                style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                onClick={handleCopy}
            />
        </OverlayTrigger>
    );
};

InlineCopyButton.propTypes = {
    text: PropTypes.string.isRequired
};

export default InlineCopyButton;
